export default __webpack_public_path__ + "static/media/14.e5884771.jpg";